var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"selectpicker form-control",attrs:{"options":_vm.options,"labelTitle":_vm.label},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }